export default "__VITE_ASSET__li_dJyRX__"